import * as React from "react";
import { Button, Typography, Card, CardContent, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BuildIcon from "@mui/icons-material/Build";
import TopBar from "../../components/TopBar/TopBar";
import { LayoutPage } from "../../components/Layout/layoutPage";
import { useNavigate } from "react-router-dom";

const Maintenance = () => {
  const navigate = useNavigate();

  return (
    <LayoutPage>
      <div style={{ flex: "0 0 auto" }}>
        <TopBar />

        <div className="d-flex justify-content-end p-3">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon />
            <span className="ms-2">INDIETRO</span>
          </Button>
        </div>
      </div>

      <Box
        component="div"
        sx={{
          flex: "1 1 auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 3,
        }}
      >
        <Card
          sx={{
            maxWidth: 500,
            textAlign: "center",
            boxShadow: 6,
            borderRadius: 3,
            p: 2,
          }}
        >
          <CardContent>
            <BuildIcon
              sx={{
                fontSize: 70,
                color: "warning.main",
                mb: 2,
              }}
            />

            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Prodotto in manutenzione
            </Typography>

            <Typography variant="body1" color="text.secondary">
              Questo prodotto è attualmente in manutenzione.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </LayoutPage>
  );
};

export default Maintenance;
